module.exports = __webpack_public_path__ + "static/personaggi_header-06833731debc343c442d2cdaeff18a49.png";